import React from 'react';

import { EspelhoFppListComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';

export function EspelhoFppList() {
    return (
        <ListagemProvider>
            <EspelhoFppListComp />
        </ListagemProvider>
    );
}
